import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
} from '@angular/core';
import {
  AuthService,
  VaultMenuAccessService,
  userIsSuperadminFromSession,
} from '@nebula/shared-vault/data-access';
import { Router } from '@angular/router';
import { AlertComponent } from 'nebula-ui-kit';
import { VaultAccessDeniedComponent } from '../vault-access-denied/vault-access-denied.component';

@Component({
  selector: 'app-vault-module-shell',
  standalone: true,
  imports: [CommonModule, VaultAccessDeniedComponent, AlertComponent],
  templateUrl: './vault-module-shell.component.html',
  styleUrls: ['./vault-module-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultModuleShellComponent {
  private readonly menuAccess = inject(VaultMenuAccessService);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private deniedToastEmitted = false;

  readonly moduleLabel = input.required<string>();
  readonly accessDenied = input(false);
  readonly loadError = input<string | null>(null);
  readonly loadErrorTitle = input('No se pudo cargar el módulo');

  isSuperadminSession(): boolean {
    return userIsSuperadminFromSession() || this.auth.isVaultSuperadmin();
  }

  private shouldSkipAccessDeniedToastForSession(): boolean {
    return (
      this.isSuperadminSession() ||
      this.auth.isVaultAdminEmpresa()
    );
  }

  constructor() {
    effect(() => {
      const denied = this.accessDenied();
      const label = this.moduleLabel();
      if (!denied) {
        this.deniedToastEmitted = false;
        return;
      }
      if (this.deniedToastEmitted) return;
      if (this.shouldSkipAccessDeniedToastForSession()) return;

      const url = this.router.url.split('?')[0].split('#')[0];
      if (url.includes('/layout/vault/') && !this.menuAccess.shouldBlockAccess(url)) return;

      this.deniedToastEmitted = true;
      this.menuAccess.notifyModuleViewAccessDenied(label, url);
    });
  }
}
